
const pageTextConfig = {
    pageTitle: "Listing Details",
    formSection: {
        gigListableSection: {
            listed: {
                title: "You gig is currently listed on GenieGig",
                description: "Your gig is currently listed on GenieGig and is visible to potential clients. In case you want to temporarily hide your gig from the platform you can unlist your gig.",
                cta: "Unlist Gig"
            },
            unlisted: {
                title: "You gig is NOT listed on GenieGig",
                description: "Your gig is currently hidden in GenieGig listing and is NOT visible to potential clients. Please enlist hide your gig on the platform to continue recieving new orders.",
                cta: "List Gig"
            }
        },
        gigTitle: "Gig Title",
        gigTitlePlaceHolder: "Enter an eye catchy title",
        gigTitleHelpTexts: [
            "Your Gig Title is the first thing any potential client will read",
            "We recommend you to keep it short, concise and catchy.(max 200 characters)"
        ],

        categoryTitle: "Category",
        subcategoryTitle: "Subcategory",
        
        gigDescription: "Gig Description",
        gigDescriptionPlaceholder: `1) Add a detailed description of your gig (max 4000 characters). ${"\n"}2) You the tips provided alongside to write an awesome description for your clients. ${"\n"}3) Add your experience and any relevant statistics `,
        gigDescriptionHelpTexts: [
            "Add description to let your clients know in detail about this gig (max 4000 characters)",
        ],

        priceTableTitle: "Price Bands",
        gigPriceTableSection: {
            gigPriceRangeTitle: "Price Range",
            approxDurationTitle: "Approx. Duration",
            descriptionTitle: "Description",
            addNewRowButtonText: "Add Another Price Range"
        },

        uploadPortFolioTitle: "Upload Portfolio Images",

        deleteBtnSection: {
            title: "Delete this Gig",
            description: "Please note that Gig deletion is a permanent action. Once the gig is deleted, it will no longer be available to you and cannot be restored. If you decide later that you want to start selling again, you will need to create new gig.",
            confirmationText: "Yes, I want to permanently delete this gig and delete the gig data",
            btnText: "Delete this Gig",

            alert: {
                confirm: 'Are you sure you want to delete the selected Gig ? This will permanently erase all the data related to this gig',
            }
        }
    },

    helpSection: {
        titleTip: {

        },

        descriptionTip: {
            tipHeading: "Write a description about your gig in 3 crisp paragraphs",
            para1Title: "1st Paragraph",
            para1Description: "Describe yourself in concise 2-3 lines",
            para2Title: "2nd Paragraph",
            para2Description: "Describe your Gig, providing all the necessary details about what you are offering (Keeping it short and to the point will enhance readability)",
            para3Title: "3rd Paragraph",
            para3Description: "Close your description",
        },

        priceTableTip: {
            mainTip: "Add price ranges for your service offering with a concise description in one line",
            noteTitle: "Note :-",
            note1: "These are the price ranges that will give the client an idea of your offering",
            note2: "The final price will be the one you might negotiate with the client"
        },

        portfolioTip: {
            mainTip: "Add the pictures describing your work/gig for eg. Screen clippings of your sample websites, posters, content, etc."
        },

        needHelpButtonText: "Need help?"
    }
}

export default pageTextConfig